import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.684 2.184a.283.283 0 01.531 0l.914 2.468c.028.078.09.14.167.168l2.468.913a.283.283 0 010 .531l-2.468.914a.283.283 0 00-.167.167l-.914 2.468a.283.283 0 01-.531 0l-.913-2.468a.283.283 0 00-.168-.167l-2.468-.914a.283.283 0 010-.53l2.468-.914a.283.283 0 00.168-.168l.913-2.468zM9.306 6.71a.554.554 0 011.04 0l1.787 4.83a.555.555 0 00.328.327l4.83 1.787a.554.554 0 010 1.04l-4.83 1.787a.554.554 0 00-.328.327l-1.787 4.83a.554.554 0 01-1.04 0l-1.787-4.83a.554.554 0 00-.327-.327l-4.83-1.787a.554.554 0 010-1.04l4.83-1.787a.555.555 0 00.327-.328l1.787-4.83z"
        fill={props.color ?? "#fff"}
      />
    </svg>
  );
}

export default SvgComponent;
